<template>
  <div class="modal-card">
    <b-loading :isFullPage="false" :active="isLoading" />
    <header class="modal-card-head">
      <span class="modal-card-title is-size-5 has-text-centered">{{
        App.EDOWebEditor.TABLE_FIELD
      }}</span>
      <div class="close-button cursor-pointer" @click.stop="onCancel">
        <b-icon icon="close" />
      </div>
    </header>

    <div class="modal-content-container">
      <section class="spacing-p-20">
        <b-field
          class="min-size mx-4"
          customClass="has-text-color-7"
          :label="`${General.FIELD_NAME}:`"
        >
          <b-input
            v-model="inputName"
            :placeholder="App.EDOWebEditor.PLACEHOLDER_NAME"
          />
        </b-field>
        <b-field class="min-size mx-4" customClass="has-text-color-7">
          <template #label>
            <span>
              {{ App.MenuMain.HELP }}
            </span>
            <span class="ml-5 optional-label">
              {{ General.OPTIONAL }}
            </span>
          </template>
          <b-input
            v-model="inputPlaceholder"
            :placeholder="App.EDOWebEditor.PLACEHOLDER_HELP"
          />
        </b-field>
      </section>

      <footer class="modal-card-foot is-justify-content-space-between">
        <b-field class="m-0">
          <b-switch
            v-model="isMandatory"
            class="has-text-color-7"
            :trueValue="true"
            :falseValue="false"
          >
            {{ App.EDOWebEditor.MANDATORY }}
          </b-switch>
        </b-field>
        <div class="buttons">
          <b-button
            :type="isContrast ? 'is-white' : 'is-green-lawn'"
            @click="confirmAction"
          >
            {{ General.SAVE }}
          </b-button>
          <b-button
            :type="isContrast ? 'is-white' : 'is-warning'"
            outlined
            @click="onCancel"
          >
            {{ General.CANCEL }}
          </b-button>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { v4 as uuidv4 } from "uuid";
import { App, General } from "@/utils/constants";

export default {
  name: "ModalAddTableDoe",

  props: {
    submit: {
      type: Function,
      required: true,
      default: () => null
    },
    inputs: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      App,
      General,
      isLoading: false,
      isMandatory: false,
      inputName: "",
      inputPlaceholder: "",
      tableId: uuidv4()
    };
  },
  computed: {
    ...mapGetters({ isContrast: "isContrast" }),
    listFieldsFiltered() {
      const regExp = RegExp(this.filterField.replace(/[.*|()]/g, ""), "i");
      return this.listFields.filter(field => regExp.test(field.name));
    },
    optionsValid() {
      const newOption = this.newOption.trim();
      return newOption.length ? [...this.options, newOption] : this.options;
    }
  },
  methods: {
    ...mapActions({
      indexerCreate: "indexerCreate",
      indexerRequest: "indexerRequest"
    }),
    inputCode() {
      return `<label role="button">
          <input
            type="file"
            accept=".csv,.xls,.xlsx,.ods,.tsv"
            class="table-${this.inputName.toUpperCase()}"
            required="${this.isMandatory}"
            title="${this.inputPlaceholder || General.TEXTS.SELECT_FILE}"
          />
        </label>`
        .replace(/\n/g, "")
        .replaceAll('"', "'");
    },
    confirmAction() {
      if (!this.inputName)
        this.snackToast.open({
          message: `${this.General.TYPE_NAME}.`,
          type: "is-danger",
          duration: 5000
        });
      else if (/\W/gi.test(this.inputName))
        this.snackToast.open({
          message: `${this.App.EDOWebEditor.FAIL_INPUT}.`,
          type: "is-danger",
          duration: 5000
        });
      else {
        const newInput = {
          name: this.inputName.toUpperCase(),
          value: this.inputCode(),
          type: "table",
          isMandatory: this.isMandatory
        };
        this.submit(newInput);

        this.close();
      }
    },
    close() {
      this.$parent.close();
    },
    onCancel() {
      this.submit(null);
      this.close();
    },
    setFilterFields(text) {
      this.filterField = text;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.modal-card {
  display: flex;
  justify-content: space-between;
  width: 100%;
  min-width: 50vw;
  min-height: 100px;
  max-height: 75vh;
  background-color: $color-1;
}

.modal-content-container {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: space-between;
  overflow: auto;
}

.min-size {
  min-width: 100px;
}

.optional-label {
  font-size: 10px;
  font-weight: 300;
  color: $color-7;
}
</style>
